import _ from "lodash";
import filter from "@/filter/filter.sub.js";
import betweenPrice from "@/components/CostManage/betweenPrice.vue"
import Vue from 'vue';
export default {
  data() {
    return {
      today: this.$moment(),
      priceKid: [{
        name: "定價",
        field: "base"
      }, {
        name: "售價",
        field: "sell"
      }, {
        name: "成本",
        field: "cost"
      }],
      costListname: [{
          name: "折價",
          value: "discash"
        },
        {
          name: "折扣",
          value: "dispa"
        },
        {
          name: "指定",
          value: "setprice"
        }
      ],
      multipledata: {
        open: false,
        method: "",
        name: "",
        smallname: "",
        discount: 1,
        price: {
          base: 0,
          sell: 900,
          cost: 0
        },
      },
      multipleCase2: {
        open: false,
        method: "",
        name: "",
        pricemethod: "",
        price: 0
      },
      pricemethod: [{
          name: "加價",
          asname: "+",
          value: "add"
        },
        {
          name: "減價",
          asname: "-",
          value: "off"
        }
      ],
      maxmethodlist: [{
        name: "大於",
        value: "more"
      }, {
        name: "小於",
        value: "less"
      }],
      caseBox: {
        open: false,
        method: "insert",
        name: "",
        source: "",
        elementsearch: {
          search: "",
          listitem: [{
            name: "絕對考上",
            value: "ELE200010020"
          }]
        },
        element: [],
        period: [],
        price: {
          base: 0,
          sell: 0,
          cost: 0
        },
        tmpdata: {}
      },
      single: {
        pro: []
      },
      singlesearch: {
        search: "",
        listitem: [{
          code: "BOK",
          name: "華語書籍",
          value: "PRO20020201010"
        }]
      },
    };
  },
  methods: {
    openmultiple(method, data = null) {
      this.multipledata.open = true;
      this.multipledata.method = method;
      if (data) {
        this.multipledata.smallname = data.smallname;
        this.multipledata.name = data.name;
        this.multipledata.price = {
          base: data.price.base,
          sell: data.price.sell,
          cost: data.price.cost
        }
      } else {
        this.multipledata.smallname = "";
        this.multipledata.name = "";
        this.multipledata.price = {
          base: this.basedata.price.base,
          sell: this.basedata.price.sell,
          cost: this.basedata.price.cost
        }
      }
    },
    openmultipleCase(method = "inesrt", data = null) {
      if (method == "insert") {
        if (data) {
          this.multipleCase2 = {
            open: true,
            method: method,
            name: data.name,
            pricemethod: data.pricemethod,
            price: data.price
          };
        } else {
          this.multipleCase2 = {
            open: true,
            method: method,
            name: "",
            pricemethod: "add",
            price: 0
          };
        }
      }
    },
    // =============================================
    changeinput(name, value, node = "") {
      if (node) {
        this.thdata[node][name] = value;
      } else {
        this.thdata[name] = value;
      }
    },
    changeinputpush(name, value, node = "") {
      let tmp = null;
      if (node) {
        tmp = this.thdata[node][name];
      } else {
        tmp = this.thdata[name];
      }
      if (tmp.indexOf(value) > -1) {
        tmp.splice(tmp.indexOf(value), 1);
      } else {
        tmp.push(value);
      };
    },
    selectMethod(method) {
      this.changeinput("method", method);
    },
    editmultipleC2(data, method = "update") {
      this.multipleCase2.open = true;
      this.multipleCase2.method = method;
      this.multipleCase2.name = data.name;
      this.multipleCase2.pricemehtod = data.pricemethod;
      this.multipleCase2.price = data.price;
      this.multipleCase2.tmpdata = data;
    },
    editmultiple(data, method = "update") {
      this.multipledata.open = true;
      this.multipledata.method = method;
      this.multipledata.name = data.name;
      this.multipledata.smallname = data.smallname
      this.multipledata.price = {
        base: data.price.base,
        sell: data.price.sell,
        cost: data.price.cost
      }
      this.multipledata.tmpdata = data;

    },
    multipleC2ok() {
      const t = this.multipleCase2;
      if (t.method == "insert") {
        this.changeinputpush("case2", {
          name: t.name,
          pricemethod: t.pricemethod,
          price: t.price,
          delete: 0,
          uid: "T_RA__" + Math.random() * 100000000
        }, "multiple");
      } else {
        t.tmpdata.name = t.name;
        t.tmpdata.pricemethod = t.pricemethod;
        t.tmpdata.price = t.price;
        t.tmpdata.delete = 0
      }
    },
    multipleok() {
      const t = this.multipledata;
      if (this.multipledata.method == "insert") {
        this.changeinputpush("case1", {
          name: t.name,
          smallname: t.smallname,
          discount: 1,
          delete: 0,
          price: {
            base: t.price.base,
            sell: t.price.sell,
            cost: t.price.cost
          },
          uid: "T_RB__" + Math.random() * 100000000
        }, "multiple");
      } else {
        const source = this.multipledata.tmpdata
        source.name = t.name;
        source.smallname = t.smallname;
        source.discount = this.multipledata.tmpdata.discount;
        source.price = {
          base: t.price.base,
          sell: t.price.sell,
          cost: t.price.cost
        }

      }
    },
    multipleDel(source) {
      this.$store.dispatch("Public/openConfirm", {
        title: "項目刪除",
        context: "確定要刪除「" + source.name + "」"
      }).then((data) => {
        console.log(data);
        if (data) {
          source.delete = 1;
        } else {

        }
        console.log(this.thdata);
      }).catch((error) => {
        console.log(error)
      });
    },
    multipleC2Del(source) {
      this.$store.dispatch("Public/openConfirm", {
        title: "項目刪除",
        context: "確定要刪除此「" + source.name + "」"
      }).then((data) => {
        console.log(data);
        if (data) {
          source.delete = 1;
        } else {

        }
        // console.log(this.thdata);
      }).catch((error) => {
        console.log(error)
      });
    },
    editCase(data, method = "update", source = "now") {
      console.log(data);
      this.caseBox.open = true;
      this.caseBox.method = method;
      //帶資料庫 element
      this.caseBox.elementsearch = {
        search: "",
        listitem: [{
          year: '108',
          name: "絕對考上",
          value: "ELE200010020"
        }]
      };

      if (method == "update") {
        this.caseBox.source = source;
        this.caseBox.name = data.name;
        this.caseBox.element = _.clone(data.element);
        this.caseBox.price = _.clone(data.price);
        if (source == "base") {
          this.caseBox.period = _.clone(this.insCostdata.period);
        } else {
          this.caseBox.period = _.clone(data.period);
        }
        this.caseBox.tmpdata = data;

      } else {
        this.caseBox.source = "";
        this.caseBox.name = "";
        this.caseBox.period = [];
        this.caseBox.element = _.clone(this.basedata.element);
        this.caseBox.tmpdata = null;
        this.caseBox.price = {
          base: this.basedata.price.base,
          sell: this.basedata.price.sell,
          cost: this.basedata.price.cost
        };
      }
    },
    caseBoxok() {
      const tCB = this.caseBox;
      if (this.caseBox.method == "insert") {
        this.thdata.casemethod.push({
          name: tCB.name,
          element: tCB.element,
          period: _.map(tCB.period, (item) => {
            return item;
          }),
          price: _.clone(tCB.price),
        });
      } else {
        this.caseBox.tmpdata.name = tCB.name;
        this.caseBox.tmpdata.element = _.clone(tCB.element);

        if (this.caseBox.source == "base") {
          this.insCostdata.period = _.clone(this.caseBox.period);
          // = _.clone(this.insCostdata.period);
        } else {
          this.caseBox.tmpdata.period = _.map(tCB.period, (item) => {
            return item;
          });
        }
        this.caseBox.tmpdata.price = _.clone(tCB.price);
      }
    },
    elementsearchbtn(
      item
    ) {
      if (filter.filter(this.caseBox.element, {
          value: item.value,
          delete: 0
        }).length > 0) {
        filter.filter(this.caseBox.element, {
          value: item.value,
          delete: 0
        })[0].number++;
      } else {
        let titem = _.clone(item);
        titem.number = 1;
        titem.delete = 0;
        this.caseBox.element.push(titem);
      }

    },
    singlesearchbtn(item) {
      console.log(filter.filter(this.single.pro, {
        value: item.value,
        delete: 0
      }));
      if (filter.filter(this.single.pro, {
          value: item.value,
          delete: 0
        }).length > 0) {
        filter.filter(this.single.pro, {
          value: item.value,
          delete: 0
        })[0].number++;
      } else {
        let titem = _.clone(item);
        titem.number = 1;
        titem.delete = 0;
        this.single.pro.push(titem);
      }
    },
    elementsearchdelete(item) {
      const index = _.findIndex(this.caseBox.element, {
        value: item.value,
        delete: 0
      });
      this.caseBox.element[index].delete = 1;
    },
    singlesearchdelete(item) {

      const index = _.findIndex(this.single.pro, {
        value: item.value,
        delete: 0
      });
      this.single.pro[index].delete = 1;
    },
    singlesearchshow() {
      console.log("hello");
      // this.singlesearch.listitem = [];
    }
  },
  computed: {
    elementsearchdata: {
      get() {
        return this.caseBox.elementsearch.search;
      },
      set(data) {
        this.caseBox.elementsearch.search = data;
      }
    },
    singlesearchdata: {
      get() {
        return this.singlesearch.search;
      },
      set(data) {
        this.singlesearch.search = data;
      }
    },
    singleProList() {
      return filter.filter(this.single.pro, {
        delete: 0
      });
    },
    caseBoxElement() {
      return filter.filter(this.caseBox.element, {
        delete: 0
      });
    },
    caseItemNowPrice() {
      return (pricelist) => {
        const today = this.today.format("YYYY-MM-DD");
        const list = pricelist.filter((item, keys) => {
          return (this.$moment(item.startdate).format("YYYY-MM-DD") <= today && this.$moment(
            item.enddate).format("YYYY-MM-DD") >= today);
        });
        if (list.length > 0) {
          const first = _.orderBy(list, "order", "asc")[0];
          // console.log();
          // const price = () => {
          const pre = filter.filter(this.costListname, {
            value: first.price.method
          })[0].name;
          let aftertext = "";
          let price = 0;
          switch (first.price.method) {
            case "discash":
              aftertext = "元";
              price = first.price.price;
              break;
            case "dispa":
              aftertext = "%";
              price = first.price.price;
              break;
            case "setprice":
              aftertext = "元";
              price = first.price.price;
              break;
          }
          return first.name + ":(" + pre + ")" + price + aftertext;
        } else {
          return "目前無優惠"
        }
      }
    },
    pricemehtod() {
      return this.multipleCase2.pricemethod ? filter.filter(this.pricemethod, {
        value: this.multipleCase2.pricemethod
      })[0].asname : "";
    },
    nowSpecification: {
      get() {
        return this.thdata.method;
      },
    },
    insCostdata() {
      return this.data['insCost'];
    },
    basedata() {
      return this.data['insBaseField'];
    },
    thdata() {
      return this.data[this.pagename];
    },

  },
  props: {
    data: Object,
    pagename: String
  },
  components: {
    betweenPrice
  }
}
